import { Component, OnInit } from '@angular/core';
import { ElementLogsService} from '../../services/element-logs.service';
import {ModalService} from 'ngx-dynamic-modal';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {VnaCampaignService} from '../../../../config/vna-campaign/services/vna-campaign.service';

@Component({
  selector: 'app-element-logs',
  templateUrl: './element-logs.component.html',
  styleUrls: ['./element-logs.component.scss']
})
export class ElementLogsComponent implements OnInit {

    elements: Array<any>;
    enabled: boolean;
    formSearch: FormGroup;
    phone: any;
    isSubmitted: boolean;

    constructor(private elementLogService: ElementLogsService, private modalService: ModalService, private campaignService: VnaCampaignService) {

        this.formSearch = new FormGroup(
            {
                'element' : new FormControl('', Validators.required),
                'type' : new FormControl('', Validators.required)
            }
        );
        this.elements= [];

    }

    ngOnInit() {

    }

    onChangeType(e): void {
        this.elements = [];
    }

    searchElement(){
        switch (this.formSearch.value.type){
            case 'phone_logs':
                this.searchLog();
                break;
            case 'campaign_data':
                this.searchCampaign();
                break;
        }
    }



    protected searchLog() {

        if(!this.formSearch.valid){
            this.isSubmitted = true;
            return;
        }

        this.enabled = true;
        this
            .elementLogService
            .getElementLogs(this.formSearch.value.element)
            .subscribe(
                result => {
                this.elements=result;
                this.enabled = false;
            })
        ;
    }

    protected searchCampaign() {
        if(!this.formSearch.valid){
            this.isSubmitted = true;
            return;
        }

        this.enabled = true;
        this
            .campaignService
            .findByPk(this.formSearch.value.element)
            .subscribe(
                (r) => {
                    this.elements.push(r);
                    this.enabled = false;
                }
            )
        ;
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/components/element-logs/element-logs.component.ts